import { Storybook } from "@tento-ui/ui/storybook";
import { DshTurnThought } from "./thought";

/** The fixture's reasoning, verbatim from `thread/fixture.ts` — the same
 * words the native skin renders, so the two cards can be read side by
 * side. */
const REASONING = "Two lanes are live, so the merge is the suspect before " +
  "the renderer is. If `seq` is per-pane then sorting on it interleaves two " +
  "independent counters, which would look exactly like this — turns " +
  "shredded across each other rather than misplaced by one.";

/** What a streaming thought actually looks like: line-broken, still going,
 * and with the sentence that matters at the BOTTOM. The collapsed line tracks
 * that last line, which is why this fixture has to be several. */
const STREAMING = [
  "Reading the failing test first.",
  "The projection arrives with null collections on a racing session.",
  "So the crash is in the renderer rather than the parser — the parser never",
  "sees a session mid-race, it only ever sees a settled one, and the eleven",
  "call sites that touch this all assume a settled shape",
].join("\n");

export class DshTurnThoughtStoryBook extends Storybook.Default {
  title(): string {
    return "Turn · dsh · thought";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Collapsed — the default",
        render: () => DshTurnThought.makeWith({ text: REASONING }),
      },
      {
        title: "Expanded",
        render: () =>
          DshTurnThought.makeWith({ text: REASONING, expanded: true }),
      },
      {
        title: "active — the line tracks the tail, and the row glares",
        render: () => DshTurnThought.makeWith({ text: STREAMING, active: true }),
      },
      {
        title: "The same thought, settled — first line, ellipsised",
        render: () => DshTurnThought.makeWith({ text: STREAMING }),
      },
      {
        title: "A summary is accepted and the label stays Think",
        render: () => {
          const $wrap = column();
          $wrap.append(
            DshTurnThought.makeWith({ text: STREAMING }),
            DshTurnThought.makeWith({
              text: STREAMING,
              summary: "Thought for 4s about the null projection",
            }),
          );
          return $wrap;
        },
      },
    ];
  }
}

function column(): HTMLElement {
  const $wrap = document.createElement("div");
  $wrap.style.display = "flex";
  $wrap.style.flexDirection = "column";
  $wrap.style.gap = "2px";
  $wrap.style.width = "100%";
  return $wrap;
}
